import React from 'react';
import { HeartIcon } from 'lucide-react';
export function DesireSection() {
  const desires = ['Que tus hijos hablen español sin vergüenza.', 'Que no pierdan la conexión con los abuelos.', 'Que no tengas que traducir en cada llamada familiar.', 'Que crezcan orgullosos de ser bilingües.', 'Que el español sea una herencia, no un arrepentimiento.'];
  return <section className="py-16 px-4 bg-gradient-to-b from-amber-50 to-white" data-id="element-7">
      <div className="max-w-4xl mx-auto" data-id="element-8">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-9">
          🎯 ¿QUÉ QUIERES REALMENTE COMO PADRE LATINO?
        </h2>

        <div className="space-y-4 mb-8" data-id="element-10">
          {desires.map((desire, index) => <div key={index} className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-11">
              <HeartIcon className="text-rose-500 flex-shrink-0 mt-1" size={24} data-id="element-12" />
              <p className="text-xl text-gray-800" data-id="element-13">{desire}</p>
            </div>)}
        </div>

        <div className="bg-amber-100 p-6 rounded-lg text-center border-2 border-amber-500" data-id="element-14">
          <p className="text-xl font-bold text-gray-900" data-id="element-15">
            Y esta guía te ayuda a lograr exactamente eso.
          </p>
        </div>
      </div>
    </section>;
}